/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wm_Quiz_Participation_Terms_TitleInputs */

const de_wm_quiz_participation_terms_title = /** @type {(inputs: Wm_Quiz_Participation_Terms_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teilnahmebedingungen`)
};

/** @type {(inputs: Wm_Quiz_Participation_Terms_TitleInputs) => LocalizedString} */
const en_wm_quiz_participation_terms_title = de_wm_quiz_participation_terms_title;

/**

* @param {Wm_Quiz_Participation_Terms_TitleInputs} inputs
* @param {{ locale?: "de" | "en" }} options
* @returns {LocalizedString}
*/
export const wm_quiz_participation_terms_title = /** @type {((inputs?: Wm_Quiz_Participation_Terms_TitleInputs, options?: { locale?: "de" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wm_Quiz_Participation_Terms_TitleInputs, { locale?: "de" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_wm_quiz_participation_terms_title(inputs)
	return en_wm_quiz_participation_terms_title(inputs)
});